import { RightOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import * as React from 'react';

interface NextButtonState { }

interface NextButtonProps extends ButtonProps {
  title?: string;
  submitting?: boolean;
  text?: string;
}

class NextButton extends React.Component<NextButtonProps, NextButtonState> {
  constructor(props: NextButtonProps) {
    super(props);

    this.state = {};
  }

  render() {
    const htmlType = this.props.htmlType ? this.props.htmlType : 'submit'
    const buttonType = this.props.type ? this.props.type : 'primary'

    return (
      <Button
        {...this.props}
        htmlType={htmlType}
        type={buttonType}
        icon={<RightOutlined />}
        loading={this.props.submitting || this.props.loading} >
        {this.props.title ?? 'Next'}
      </Button>
    );
  }
}

export default NextButton;
